module.exports = __webpack_public_path__ + "static/media/jorge.e386c964.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/jorge.jpg
// module id = 719
// module chunks = 0